import { ExtraVehicleInformationModel } from './ExtraVehicleInformationModel'

export class PnetSubmitQuoteModel {
  constructor() {
    this.quoteId = ''
    this.extraVehicleInformation = new ExtraVehicleInformationModel()
    this.imageIds = []
  }
}
